import styled from 'styled-components';
import {styledByDevice} from "../../../../../../themes/architecture/styled-by-device";
import {STICKY_NAVBAR} from "../../css-constants";
import {CssRule} from '../../../../../../themes/architecture/css-helpers/css-rule';

const DefaultBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: ${props => props.theme.colors.bodyBackground};
    font-size: 1rem;
    border-bottom: 1px solid ${props => props.theme.colors.buttonDark};
    position: sticky;

    &.${STICKY_NAVBAR} {
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        ${CssRule.For.embededHybrid.build()} & {
            top: 0;
            margin: 0 env(safe-area-inset-left);
        }
    }
`;

const PCBox = styled(DefaultBox)`
    &.${STICKY_NAVBAR}{
        left: 23rem;
    }
`;

const MobileBox = styled(DefaultBox)`
    font-size: 0.85rem;
`;

export const LiveCasinoNavbarDefaultBox = styledByDevice(PCBox, MobileBox);